import { goto } from "$app/navigation";
import { getSettingPaymentPeriod } from "../api/EnzianSettingsApi";
import { confirmState } from "../basic/dialog/ConfirmStore";
import { ROUTE_DOCUMENT } from "../types/DocumentTypes";
import Big from "big.js";
import { _ } from "svelte-i18n";
import { get, writable } from "svelte/store";
export var DocumentViewMode;
(function (DocumentViewMode) {
    DocumentViewMode["FOLDER"] = "folder";
    DocumentViewMode["LIST"] = "list";
    DocumentViewMode["MONEY"] = "money";
})(DocumentViewMode || (DocumentViewMode = {}));
export const recentlyUsedDocumentStore = writable(new Map());
/*
* View modes
*/
export const viewModeStore = writable(DocumentViewMode.FOLDER);
/**
 * Drag store for moving documents.
 */
export const documentDragStore = writable(null);
export function openDocument(item, newTab = false) {
    //Check if the document was recently opened
    const recentlyOpened = get(recentlyUsedDocumentStore).get(item.id) || null;
    if (recentlyOpened) {
        //Get the translation store.
        confirmState.set({
            bodyText: "",
            successCallback: () => internalOpenDocument(item.id, newTab),
            warningText: get(_)("document_list_view.lbl_open_warning").replaceAll("{}", recentlyOpened.lastOpenedLoginName),
            acceptButtonText: get(_)("general.bt_edit"),
        });
    }
    else {
        internalOpenDocument(item.id, newTab);
    }
}
function internalOpenDocument(id, newTab) {
    //Navigate to the detail page.
    if (newTab) {
        window.open("/" + ROUTE_DOCUMENT + "/" + id, '_blank');
    }
    else {
        goto("/" + ROUTE_DOCUMENT + "/" + id);
    }
}
/**
 * Build a create document request object.
 * @param isRegie
 * @param settingDocumentType
 * @param settingDocumentSetting
 * @param partnerAddress
 * @returns
 */
export async function buildCreateDocumentRequest(isRegie, settingDocumentType, settingDocumentSetting = null, partnerAddress = null) {
    const request = {
        name: get(_)('document_list_view.lbl_document_default_name'),
        shortName: null,
        type: settingDocumentType.defaultName,
        isRegie: isRegie,
        total: new Big(0),
        amountToPay: new Big(0),
        fkSettingDocumentNameGenerator: settingDocumentType.settingDocumentNameGenerator?.id,
        createFactorGroups: null,
        isMigration: false,
        isMobileEditable: false, //Set the mobile flag
        openingText: settingDocumentType.openingText?.name,
        closingText: settingDocumentType.closingText?.name,
        createPaymentPeriodValues: settingDocumentType.settingPaymentPeriod
            ? settingDocumentType.settingPaymentPeriod.settingPaymentPeriodValues.map((sppv) => {
                return {
                    name: sppv.name,
                    days: sppv.days,
                    percentage: sppv.percentage
                };
            })
            : null,
        //Add the alias as well
        paymentPeriodAlias: settingDocumentType.settingPaymentPeriod
            ? settingDocumentType.settingPaymentPeriod.exportAlias
            : undefined,
    };
    //Check if we have a partner address set, if so create the address for the given document.
    if (partnerAddress) {
        request.createAddresses = [
            {
                title: partnerAddress.title,
                firmName: partnerAddress.firmName,
                name: partnerAddress.name,
                firstName: partnerAddress.firstName,
                addon: partnerAddress.addon,
                streetFirst: partnerAddress.streetFirst || "",
                streetSecond: partnerAddress.streetSecond,
                zip: partnerAddress.zip || "",
                place: partnerAddress.place || "",
                addressPosition: settingDocumentSetting?.defaultAddressPositionNr || 0,
                relationTag: partnerAddress.relationTag,
                fkPartnerAddress: partnerAddress.id,
                countryCode: partnerAddress.countryCode || "CH"
            }
        ];
        //If the partner has a discount we add it as well
        if (partnerAddress.discount) {
            //Add the condition to the creat object
            request.createConditions = [
                {
                    name: get(_)('documentview.address_edit.lbl_partner_condition_name'),
                    percentage: partnerAddress.discount,
                    conditionLevel: 1,
                    isSequential: true,
                    isIgnoreNet: true,
                    isFromPartner: true
                }
            ];
        }
        //Check if we have a bound payment period
        if (partnerAddress.fkSettingPaymentPeriod) {
            //Load the information about the setting
            const setting = await getSettingPaymentPeriod(partnerAddress.fkSettingPaymentPeriod);
            //Mapp the settings
            request.createPaymentPeriodValues = setting.settingPaymentPeriodValues.map((oldValue) => {
                return {
                    name: oldValue.name,
                    days: oldValue.days,
                    percentage: oldValue.percentage
                };
            });
            //Add the alias as well
            request.paymentPeriodAlias = setting.exportAlias;
        }
    }
    //Return the built request.
    return request;
}
